import type { AnyFilterSchema } from "../types.ts";

export const groupOnlyFilters = {
  group: { keys: ["id", "label"] },
} as const satisfies AnyFilterSchema;

export const groupAndRoleFilters = {
  group: { keys: ["id", "label"] },
  role: { keys: ["id", "label"] },
} as const satisfies AnyFilterSchema;

export type DirectoryGroupFilters = typeof groupOnlyFilters;

export type DirectoryGroupAndRoleFilters = typeof groupAndRoleFilters;
